import { LocaleService } from "./localeService";

export const MessageServiceConstants = {
	message: "appMessage"
};

export class MessageService {
	constructor() {
		this._localeService = new LocaleService();
	}

	ShowMessage(message) {
		const messageElement = document.getElementById(MessageServiceConstants.message);

		if (message != null) {
			const translatedMessage = this._localeService.Translate(`oauth.${message}`);
			messageElement.innerHTML = translatedMessage;
		}

		const isActive = !!message;
		messageElement.classList.toggle("active", isActive);
	}
}
